import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1254.000000 1254.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1254.000000) scale(0.100000,-0.100000)">

<path d="M6130 12389 c-221 -22 -450 -90 -712 -212 -80 -37 -416 -212 -533
-277 -16 -9 -70 -38 -120 -65 -49 -27 -178 -97 -285 -156 -107 -59 -334 -183
-505 -276 -352 -192 -899 -496 -1115 -618 -80 -45 -170 -96 -200 -113 -56 -31
-76 -42 -305 -174 -489 -282 -736 -458 -946 -675 -317 -327 -513 -758 -586
-1288 -17 -122 -18 -265 -18 -2205 0 -2247 -2 -2164 55 -2450 47 -230 118
-433 228 -644 177 -340 413 -590 797 -841 183 -121 243 -156 1053 -619 378
-216 811 -465 962 -553 151 -88 356 -206 455 -263 99 -57 227 -131 285 -165
58 -34 182 -105 275 -157 466 -261 701 -366 965 -432 178 -45 315 -60 460 -52
385 22 705 154 1525 631 88 51 361 210 607 354 400 233 604 350 1113 638 83
47 179 102 215 123 36 20 130 75 210 120 449 258 648 383 806 510 511 409 812
985 874 1670 12 142 34 3100 27 3730 -6 495 -13 586 -67 840 -96 453 -305 844
-606 1130 -191 181 -380 310 -944 643 -156 92 -842 480 -1090 616 -47 26 -146
81 -220 123 -278 156 -778 434 -870 483 -52 28 -185 100 -295 160 -262 141
-544 280 -675 332 -281 110 -570 156 -820 132z m640 -1084 c643 -78 1160 -233
1731 -520 361 -181 612 -346 959 -629 395 -322 744 -707 1037 -1146 524 -784
800 -1667 820 -2621 18 -859 -159 -1691 -519 -2429 -114 -234 -179 -348 -325
-565 -202 -302 -357 -491 -612 -745 -410 -410 -855 -728 -1386 -990 -745 -368
-1439 -525 -2253 -507 -717 16 -1412 186 -2104 515 -387 184 -861 490 -1168
752 -35 30 -80 69 -100 85 -80 68 -328 317 -414 415 -286 324 -505 648 -701
1035 -343 677 -514 1376 -532 2171 -23 1035 259 2005 841 2898 178 273 438
591 690 841 886 881 1931 1360 3181 1459 130 10 726 -3 855 -19z"/>
<path d="M6070 10860 l0 -50 75 0 75 0 0 -210 0 -210 60 0 60 0 2 206 3 207
70 1 70 1 3 53 3 52 -210 0 -211 0 0 -50z"/>
<path d="M6752 10881 c-17 -12 -252 -469 -252 -490 0 -7 23 -11 58 -11 l59 0
18 41 19 41 60 -6 c177 -18 164 -14 171 -55 9 -54 14 -58 79 -66 54 -7 59 -6
52 10 -3 9 -18 63 -32 119 -34 135 -106 400 -109 404 -6 7 -115 18 -123 13z
m71 -238 c14 -50 23 -93 21 -96 -4 -3 -125 13 -132 18 -2 2 16 41 40 88 23 48
43 85 44 84 1 -1 13 -43 27 -94z"/>
<path d="M5653 10873 c-18 -2 -33 -6 -33 -9 0 -3 -31 -122 -70 -266 -38 -144
-70 -267 -70 -273 0 -9 15 -10 58 -3 31 5 60 12 63 16 3 4 11 26 18 49 13 47
5 44 155 63 44 6 80 9 81 8 2 -2 12 -22 24 -45 23 -46 28 -48 108 -35 l42 7
-84 155 c-47 85 -107 197 -132 248 l-48 92 -40 -2 c-22 0 -55 -3 -72 -5z m73
-166 c6 -12 26 -48 44 -80 18 -32 30 -60 27 -63 -7 -7 -130 -24 -135 -19 -6 6
39 185 47 185 3 0 11 -10 17 -23z"/>
<path d="M7382 10523 c-34 -131 -63 -243 -62 -249 0 -11 63 -34 93 -34 10 0
20 21 31 68 14 56 22 70 47 84 29 17 30 17 38 -5 55 -139 71 -183 71 -193 0
-11 130 -58 137 -50 2 2 -15 50 -38 107 -23 57 -50 126 -61 153 -10 27 -17 54
-15 60 3 6 57 45 120 86 64 41 116 78 116 81 1 6 -57 30 -105 43 -13 4 -32 -3
-55 -19 -95 -71 -189 -133 -190 -127 -2 11 -1 14 25 112 l24 91 -23 9 c-12 5
-38 12 -56 15 l-34 6 -63 -238z"/>
<path d="M4985 10740 c-22 -5 -83 -22 -135 -39 -79 -24 -94 -32 -92 -47 2 -11
18 -68 36 -129 18 -60 48 -166 67 -235 18 -69 34 -127 35 -128 3 -5 231 63
275 81 50 22 115 90 135 143 12 32 15 62 12 111 -8 111 -61 192 -150 230 -38
17 -136 23 -183 13z m142 -130 c87 -53 96 -187 17 -249 -20 -16 -138 -61 -159
-61 -1 0 -8 21 -15 48 -7 26 -25 92 -41 146 -16 55 -26 102 -23 105 11 12 91
29 139 30 33 1 61 -6 82 -19z"/>
<path d="M7965 10558 c-12 -76 -65 -459 -65 -475 0 -12 16 -25 47 -38 26 -11
50 -21 53 -23 4 -1 44 41 91 95 46 54 93 108 103 121 21 24 38 29 31 10 -6
-17 -45 -276 -45 -299 0 -17 71 -59 101 -59 8 0 31 21 52 48 21 26 55 65 75
87 20 22 66 74 102 115 36 41 77 88 92 105 16 16 28 33 28 36 0 7 -110 53
-114 48 -2 -2 -41 -49 -87 -104 -46 -55 -94 -114 -106 -130 -29 -39 -29 -31 2
152 14 81 25 155 25 163 0 14 -71 50 -95 50 -6 0 -19 -13 -29 -28 -35 -48
-189 -222 -193 -218 -3 2 7 72 21 155 14 83 26 158 26 166 0 14 -76 55 -100
55 -5 0 -12 -15 -15 -32z"/>
<path d="M4030 10364 c-30 -19 -57 -41 -61 -51 -3 -10 -14 -70 -24 -133 -9
-63 -20 -121 -24 -127 -4 -8 -27 21 -60 77 -30 50 -58 90 -63 90 -10 0 -98
-50 -98 -55 0 -7 254 -431 266 -444 11 -12 19 -10 58 13 25 15 46 29 46 32 0
3 -16 34 -35 68 -19 35 -35 74 -35 87 0 52 10 52 129 3 123 -51 130 -51 205
-3 l50 31 -65 24 c-139 52 -255 98 -265 106 -8 6 -4 47 13 145 13 76 22 145
21 154 -3 13 -13 9 -58 -17z"/>
<path d="M8723 10019 c-81 -56 -183 -124 -225 -152 -43 -29 -78 -55 -78 -58 0
-6 88 -69 97 -69 3 0 21 11 39 25 18 14 36 25 41 25 4 -1 44 -27 88 -59 83
-60 85 -64 72 -128 -6 -29 -3 -35 42 -67 56 -41 61 -43 61 -18 0 9 25 127 55
262 30 135 55 250 55 257 0 6 -22 27 -50 47 l-49 36 -148 -101z m103 -144
c-13 -47 -25 -88 -28 -91 -6 -5 -108 63 -108 72 0 8 145 111 152 108 3 -2 -4
-42 -16 -89z"/>
<path d="M3318 9882 c-26 -20 -47 -44 -47 -52 -1 -8 13 -60 29 -115 16 -55 51
-172 76 -260 26 -88 49 -163 53 -167 3 -3 27 13 53 36 l47 42 -14 49 c-12 39
-13 51 -3 60 7 7 47 39 89 73 l76 61 43 -29 43 -28 53 40 c30 22 54 42 54 43
0 2 -60 38 -132 81 -73 42 -180 106 -238 141 -58 35 -112 63 -120 62 -8 0 -36
-17 -62 -37z m160 -151 c114 -67 110 -60 47 -110 -31 -24 -59 -41 -61 -38 -8
8 -63 187 -57 187 2 0 35 -18 71 -39z"/>
<path d="M9096 9628 c-91 -106 -166 -195 -165 -198 0 -3 19 -21 41 -40 l41
-35 53 58 c44 49 57 58 81 55 15 -2 27 -7 26 -13 -1 -5 -4 -62 -8 -126 l-8
-116 46 -38 c50 -42 62 -47 62 -25 4 110 19 321 24 324 3 2 73 12 154 22 81 9
147 20 146 23 -1 3 -23 26 -50 50 l-48 43 -125 -16 c-69 -9 -133 -16 -142 -16
-10 0 11 29 55 78 39 42 71 82 71 87 0 9 -73 75 -83 75 -3 0 -80 -87 -171
-192z"/>
<path d="M6185 9681 c-122 -30 -250 -176 -339 -387 -18 -44 -36 -91 -40 -107
-6 -25 -4 -27 16 -22 36 8 380 25 390 19 4 -3 8 46 8 108 0 62 3 177 7 256 3
83 2 142 -3 141 -5 -1 -22 -4 -39 -8z"/>
<path d="M6310 9591 c0 -54 3 -166 7 -249 l6 -150 106 -7 c58 -3 151 -10 206
-14 55 -4 101 -7 103 -6 6 5 -50 142 -85 210 -94 183 -199 287 -310 308 l-33
7 0 -99z"/>
<path d="M5950 9651 c-137 -44 -270 -130 -381 -249 -70 -74 -164 -204 -203
-281 l-18 -34 24 6 c24 6 208 41 287 54 43 8 44 9 62 69 24 78 120 266 166
324 20 25 56 64 82 87 25 24 44 42 41 42 -3 -1 -30 -9 -60 -18z"/>
<path d="M6585 9613 c86 -87 159 -210 221 -373 l32 -85 128 -22 c71 -11 149
-26 174 -32 24 -5 45 -9 47 -8 6 7 -125 203 -177 265 -123 146 -298 262 -444
296 -28 7 -27 5 19 -41z"/>
<path d="M5569 9551 c-95 -41 -126 -59 -246 -138 -169 -112 -320 -265 -437
-445 -31 -47 -56 -89 -56 -93 0 -4 17 7 38 23 55 43 174 101 282 136 l95 31
40 75 c88 164 238 345 343 415 73 48 57 47 -59 -4z"/>
<path d="M6890 9572 c126 -87 268 -260 386 -471 17 -29 32 -38 124 -70 120
-43 195 -79 263 -127 26 -19 47 -31 47 -28 0 15 -114 179 -173 249 -157 185
-388 355 -596 439 -74 30 -86 32 -51 8z"/>
<path d="M2961 9528 c-96 -27 -197 -133 -214 -225 -13 -65 42 -151 110 -174
44 -14 87 0 184 62 78 50 106 58 127 37 46 -46 -36 -145 -136 -166 l-37 -8 4
-49 c4 -64 7 -68 44 -59 55 12 128 54 177 103 110 110 100 257 -21 305 -56 23
-96 13 -186 -46 -94 -62 -128 -70 -144 -36 -22 50 50 133 126 145 39 6 38 -2
19 93 -3 17 -9 30 -12 29 -4 0 -22 -5 -41 -11z"/>
<path d="M9568 9292 c-142 -130 -156 -147 -170 -214 -14 -68 0 -119 47 -181
49 -64 115 -101 180 -101 74 0 85 8 339 225 l31 26 -29 42 c-16 23 -33 44 -37
47 -4 2 -55 -36 -113 -86 -170 -146 -188 -155 -246 -125 -37 19 -60 62 -60
111 0 32 8 45 53 88 28 28 87 80 130 116 42 35 77 68 77 73 0 14 -63 87 -74
87 -6 -1 -64 -49 -128 -108z"/>
<path d="M5955 9079 c-209 -14 -186 -1 -218 -132 -36 -149 -56 -279 -64 -411
l-6 -109 79 6 c43 4 168 10 277 13 l197 7 0 318 0 319 -67 -1 c-38 -1 -126 -6
-198 -10z"/>
<path d="M6320 8771 l0 -319 208 -6 c114 -4 239 -9 277 -12 l71 -6 -8 104 c-9
115 -38 296 -70 435 l-21 92 -36 6 c-48 7 -303 25 -368 25 l-53 0 0 -319z"/>
<path d="M2497 9032 c-18 -26 -37 -52 -40 -58 -4 -6 29 -77 72 -158 44 -80 76
-146 73 -147 -19 -3 -90 3 -200 17 -140 18 -130 21 -175 -57 -25 -44 -25 -47
-9 -61 16 -14 108 -79 314 -221 l97 -67 30 44 c17 25 31 48 31 53 0 5 -58 49
-129 98 -71 50 -128 91 -127 92 1 2 58 -4 127 -11 221 -26 219 -26 219 -5 0 9
-33 83 -74 163 -41 80 -72 146 -70 146 4 0 65 -41 189 -128 33 -23 65 -42 71
-42 16 0 78 90 68 99 -5 4 -104 71 -221 149 l-212 142 -34 -48z"/>
<path d="M5575 9039 c-168 -30 -261 -52 -271 -62 -53 -55 -187 -597 -147 -597
5 0 58 6 119 14 60 8 150 18 200 21 l91 7 7 87 c10 129 45 354 71 453 l22 88
-21 -1 c-11 -1 -43 -5 -71 -10z"/>
<path d="M6874 9034 c29 -72 73 -334 91 -534 l7 -76 186 -18 c103 -9 197 -20
209 -23 22 -5 23 -3 17 43 -13 124 -40 249 -76 364 -58 180 -67 196 -125 209
-79 17 -205 40 -262 47 -51 7 -54 6 -47 -12z"/>
<path d="M5095 8927 c-103 -37 -202 -89 -280 -148 -59 -45 -73 -72 -121 -240
-27 -92 -55 -282 -43 -287 4 -2 25 6 46 16 51 26 160 59 269 81 l89 18 7 64
c17 156 76 384 132 512 10 22 7 22 -99 -16z"/>
<path d="M7345 8943 c55 -126 98 -286 124 -467 l16 -110 70 -13 c109 -20 194
-44 264 -75 35 -15 66 -28 68 -28 11 0 -12 165 -37 265 -48 189 -63 220 -134
272 -70 52 -211 123 -306 152 -79 25 -74 25 -65 4z"/>
<path d="M9955 8759 c-88 -55 -183 -116 -212 -135 l-52 -34 31 -50 c18 -29 35
-47 42 -43 6 4 34 22 63 40 29 18 56 33 60 33 5 0 17 -14 27 -31 l19 -32 -43
-87 -43 -88 38 -61 37 -62 35 78 c19 43 39 89 44 102 7 18 12 21 23 12 51 -43
157 -27 213 31 40 42 59 110 44 163 -12 46 -141 265 -156 265 -5 0 -82 -45
-170 -101z m183 -108 c34 -63 39 -90 21 -122 -12 -24 -55 -42 -80 -34 -18 6
-89 112 -89 134 0 9 95 78 110 80 3 0 20 -26 38 -58z"/>
<path d="M5910 8340 c-96 -4 -193 -8 -214 -9 l-39 -1 6 -212 c6 -203 13 -282
37 -429 l11 -66 76 -7 c42 -3 156 -6 255 -6 l178 0 -2 368 -3 367 -65 1 c-36
0 -144 -2 -240 -6z"/>
<path d="M6320 7980 l0 -373 250 5 c138 3 252 7 255 9 15 16 46 312 52 495 l6
212 -114 6 c-63 3 -189 9 -281 12 l-168 6 0 -372z"/>
<path d="M5327 8305 c-64 -7 -134 -16 -154 -20 l-36 -6 7 -147 c10 -230 51
-456 85 -466 22 -7 177 -24 289 -32 107 -8 99 -23 77 136 -8 58 -20 205 -27
328 l-12 222 -55 -1 c-31 -1 -109 -7 -174 -14z"/>
<path d="M6972 8179 c-4 -203 -23 -414 -47 -526 -5 -21 -2 -23 35 -23 43 0
310 27 346 35 24 5 45 80 69 243 17 121 29 353 18 368 -9 11 -165 31 -321 41
l-98 6 -2 -144z"/>
<path d="M10208 8202 c-120 -59 -218 -113 -218 -120 0 -19 39 -92 49 -92 9 0
442 208 450 216 8 7 -42 104 -53 103 -6 0 -109 -49 -228 -107z"/>
<path d="M4905 8244 c-107 -23 -201 -55 -239 -80 -16 -11 -19 -24 -18 -76 1
-35 10 -105 18 -156 18 -102 20 -105 119 -155 75 -37 319 -107 331 -94 2 2 -3
26 -11 53 -28 94 -46 230 -52 382 -5 131 -8 152 -22 151 -9 0 -65 -11 -126
-25z"/>
<path d="M7486 8138 c-7 -142 -28 -309 -51 -398 -8 -30 -13 -55 -12 -57 2 -1
43 6 92 16 114 24 241 70 297 109 41 28 45 35 57 99 7 37 15 107 18 154 l6 86
-30 21 c-48 34 -159 66 -334 96 l-36 6 -7 -132z"/>
<path d="M1987 8154 l-28 -57 24 -26 c45 -51 283 -316 312 -348 15 -18 32 -33
36 -33 8 0 59 92 59 105 0 3 -16 22 -35 43 l-34 38 47 97 47 97 55 0 56 0 27
56 c16 31 27 57 25 58 -5 4 -432 26 -498 26 l-66 0 -27 -56z m321 -69 c1 -1
-12 -32 -29 -69 l-32 -67 -21 23 c-11 13 -43 47 -71 77 l-50 53 100 -7 c55 -4
101 -9 103 -10z"/>
<path d="M4733 7678 c71 -187 184 -363 337 -522 264 -275 613 -453 983 -502
159 -21 399 -14 542 16 412 87 764 311 1018 648 63 85 194 337 203 392 4 26 3
31 -5 19 -24 -37 -203 -103 -392 -143 -21 -5 -30 -17 -49 -68 -70 -193 -207
-403 -333 -511 -69 -58 -196 -143 -252 -168 -67 -30 -241 -67 -374 -79 -179
-18 -433 7 -586 57 -278 89 -512 332 -640 662 -34 85 -44 103 -65 107 -200 45
-309 84 -381 135 l-29 21 23 -64z"/>
<path d="M5255 7543 c11 -48 72 -178 115 -249 126 -207 285 -339 488 -404 51
-17 97 -30 102 -30 6 0 -5 14 -25 32 -107 93 -219 319 -281 564 l-18 72 -95 6
c-87 6 -168 16 -260 32 -33 5 -33 5 -26 -23z"/>
<path d="M7230 7560 c-25 -5 -109 -14 -187 -21 l-141 -12 -22 -86 c-57 -228
-156 -427 -266 -538 -24 -24 -40 -43 -36 -43 4 0 40 9 80 20 182 51 354 180
474 358 78 115 178 335 152 331 -5 -1 -29 -5 -54 -9z"/>
<path d="M5740 7499 c0 -43 76 -263 125 -364 88 -179 198 -282 321 -301 l41
-6 -5 333 c-2 184 -7 337 -11 340 -3 4 -111 9 -238 12 -220 4 -233 3 -233 -14z"/>
<path d="M6498 7513 l-178 -3 0 -99 c0 -54 -3 -207 -7 -341 l-6 -243 44 7
c140 22 263 151 356 376 35 83 93 269 93 296 0 11 -15 13 -62 12 -35 -1 -143
-4 -240 -5z"/>
<path d="M4820 7063 c-692 -39 -1362 -139 -1985 -294 -259 -65 -302 -78 -683
-199 -184 -59 -248 -86 -131 -56 235 62 810 160 1201 206 587 68 875 84 1520
85 306 0 554 3 550 6 -4 3 -37 26 -73 51 -36 26 -106 83 -157 127 -101 90 -80
83 -242 74z"/>
<path d="M7500 7010 c-59 -56 -180 -152 -238 -190 -21 -13 17 -15 362 -11 743
6 1318 -37 2096 -159 181 -28 551 -105 645 -134 69 -21 68 -12 -2 14 -791 297
-1757 490 -2678 535 l-120 6 -65 -61z"/>
<path d="M2689 6292 c-73 -123 -168 -288 -199 -342 -20 -36 -155 -267 -299
-514 -144 -246 -265 -454 -268 -462 -4 -12 29 -14 200 -14 l206 0 19 28 c17
24 160 270 414 715 50 86 93 157 97 157 4 0 19 -26 35 -57 15 -32 47 -92 70
-133 54 -94 196 -366 196 -374 0 -3 -90 -6 -199 -6 l-199 0 -86 -148 c-47 -82
-88 -156 -92 -165 -6 -16 36 -17 575 -17 320 0 581 2 581 5 0 9 -78 161 -140
275 -31 58 -89 167 -129 244 -40 76 -78 148 -85 160 -7 11 -44 80 -81 151 -37
72 -115 219 -173 328 l-106 197 -160 0 -161 0 -16 -28z"/>
<path d="M3815 6308 c-3 -7 -4 -312 -3 -678 l3 -665 183 -3 182 -2 2 272 c2
150 2 330 0 401 -1 70 2 127 6 127 4 -1 45 -53 92 -117 79 -107 377 -491 404
-521 14 -14 43 21 342 417 l169 225 3 -402 2 -402 190 0 190 0 0 680 0 680
-219 0 -220 0 -143 -207 c-78 -115 -178 -261 -222 -326 -44 -64 -84 -113 -88
-109 -5 5 -71 100 -148 213 -76 112 -174 255 -216 317 l-77 112 -214 0 c-162
0 -215 -3 -218 -12z"/>
<path d="M6020 6306 c-66 -19 -107 -42 -163 -94 -124 -117 -160 -324 -83 -486
41 -87 109 -146 221 -192 l70 -29 473 -5 474 -5 29 -33 c55 -61 30 -150 -49
-172 -23 -6 -257 -10 -639 -10 l-603 0 0 -160 0 -161 683 4 c733 3 708 1 813
55 57 29 131 113 167 190 30 63 32 73 32 182 -1 107 -3 119 -30 175 -50 102
-140 177 -260 216 -29 9 -164 14 -513 18 l-474 6 -24 28 c-33 39 -33 105 0
144 l24 28 543 5 542 5 88 153 88 152 -682 -1 c-512 -1 -693 -4 -727 -13z"/>
<path d="M8080 6133 c-57 -104 -120 -217 -140 -253 -69 -121 -237 -424 -333
-600 -52 -96 -111 -204 -131 -238 -20 -35 -36 -68 -36 -73 0 -5 85 -9 194 -9
l194 0 64 118 c36 64 128 230 205 367 161 288 194 347 218 394 l17 34 35 -64
c33 -63 255 -495 261 -511 2 -4 -85 -9 -193 -10 l-197 -3 -27 -50 c-14 -27
-52 -96 -84 -151 -31 -56 -57 -107 -57 -113 0 -8 159 -11 560 -11 373 0 560 3
560 10 0 6 -52 113 -117 238 -155 304 -468 906 -499 962 -14 25 -37 69 -51 98
l-27 52 -157 0 -156 0 -103 -187z"/>
<path d="M9270 5635 l0 -675 175 0 175 0 0 317 0 318 318 -318 317 -317 223 0
c122 0 222 2 222 5 0 3 -153 159 -340 347 l-340 343 43 39 c23 22 119 114 212
205 94 91 227 221 297 289 l126 122 -221 0 -222 0 -70 -66 c-57 -54 -257 -246
-522 -501 -18 -18 -36 -33 -38 -33 -3 0 -5 135 -5 300 l0 300 -175 0 -175 0 0
-675z"/>
<path d="M2870 4335 l0 -245 133 0 c142 1 184 10 241 54 76 57 109 202 67 290
-12 25 -40 61 -61 80 -55 50 -120 66 -262 66 l-118 0 0 -245z m242 135 c20 -6
50 -26 67 -46 26 -29 31 -43 31 -87 0 -98 -56 -147 -169 -147 l-61 0 0 138 c0
76 3 142 7 145 10 10 83 8 125 -3z"/>
<path d="M3680 4571 c0 -5 -42 -114 -94 -242 -52 -128 -93 -235 -91 -238 2 -4
30 -5 62 -3 l59 4 16 41 15 42 108 0 108 0 15 -42 14 -43 63 0 64 0 -14 38
c-7 20 -37 93 -65 162 -29 69 -67 161 -85 205 l-33 80 -71 3 c-41 2 -71 -1
-71 -7z m110 -211 c16 -40 30 -77 30 -81 0 -5 -29 -9 -65 -9 -36 0 -65 4 -65
10 0 11 46 135 56 151 8 14 10 12 44 -71z"/>
<path d="M4170 4530 l0 -50 70 0 70 0 0 -195 0 -195 60 0 60 0 0 195 0 195 70
0 70 0 0 50 0 50 -200 0 -200 0 0 -50z"/>
<path d="M4881 4558 c-5 -13 -50 -122 -99 -243 -49 -121 -88 -222 -87 -225 2
-3 30 -4 62 -2 l59 4 16 41 15 42 108 0 108 0 15 -42 14 -43 63 0 63 0 -97
243 -98 242 -67 3 c-61 3 -67 1 -75 -20z m108 -191 c17 -43 31 -82 31 -87 0
-6 -29 -10 -65 -10 -36 0 -65 4 -65 9 0 5 11 40 25 77 14 38 28 75 31 83 6 19
8 16 43 -72z"/>
<path d="M5785 4570 c-3 -5 -4 -114 -2 -242 l3 -233 57 -3 57 -3 0 66 c0 66
19 116 44 115 6 -1 40 -41 76 -90 l65 -90 68 0 c37 0 67 2 67 5 0 3 -41 58
-91 122 -50 65 -94 124 -96 131 -3 7 21 42 53 78 33 36 76 86 97 110 l39 44
-71 0 -71 0 -87 -101 -88 -101 -3 101 -3 101 -54 0 c-29 0 -57 -4 -60 -10z"/>
<path d="M6420 4553 c22 -73 91 -297 115 -375 l26 -88 63 0 63 0 33 118 c18
64 38 133 45 152 l13 35 10 -25 c9 -25 31 -97 66 -222 l17 -58 63 0 63 0 33
108 c18 59 50 162 71 230 22 68 39 130 39 137 0 12 -14 15 -59 15 l-59 0 -21
-77 c-36 -130 -67 -232 -72 -237 -2 -3 -25 66 -50 152 l-45 157 -54 3 -55 3
-27 -93 c-14 -51 -34 -120 -44 -153 -9 -33 -20 -63 -23 -67 -4 -4 -26 65 -50
152 l-44 160 -63 0 -63 0 9 -27z"/>
<path d="M7347 4339 c-53 -132 -96 -243 -93 -247 2 -4 30 -5 61 -4 56 4 57 4
75 48 l19 44 101 0 101 0 20 -45 20 -45 61 0 c53 0 59 2 54 18 -4 9 -48 119
-99 245 l-91 227 -66 0 -65 0 -98 -241z m196 29 c15 -40 27 -79 27 -85 0 -9
-18 -13 -58 -13 -32 0 -61 2 -64 5 -6 7 53 165 61 165 4 0 19 -33 34 -72z"/>
<path d="M7960 4335 l0 -245 60 0 60 0 0 73 c0 60 4 77 19 91 11 10 24 15 30
12 6 -4 38 -45 71 -91 l61 -85 70 0 70 0 -28 37 c-15 21 -61 80 -101 132 -72
93 -73 94 -54 115 10 12 53 60 95 107 42 48 77 89 77 93 0 13 -128 6 -142 -7
-7 -8 -47 -53 -88 -100 l-75 -87 -3 100 -3 100 -59 0 -60 0 0 -245z"/>
<path d="M8590 4408 c0 -194 10 -231 69 -281 86 -72 254 -61 324 22 39 47 47
90 47 269 l0 163 -57 -3 -58 -3 0 -160 c0 -135 -3 -165 -17 -187 -24 -36 -78
-53 -122 -38 -58 19 -61 27 -66 214 l-5 171 -57 3 -58 3 0 -173z"/>
<path d="M9260 4335 l0 -245 60 0 59 0 3 78 3 77 31 3 c29 3 35 -2 82 -77 l52
-81 65 0 c36 0 65 2 65 5 0 3 -25 41 -55 85 l-56 79 30 16 c87 45 103 181 29
252 -45 43 -91 53 -240 53 l-128 0 0 -245z m280 125 c24 -24 26 -67 3 -92 -13
-14 -31 -18 -90 -18 l-73 0 0 65 0 65 70 0 c57 0 74 -4 90 -20z"/>
<path d="M9900 4335 l0 -245 55 0 55 0 0 245 0 245 -55 0 -55 0 0 -245z"/>
<path d="M2124 4336 c-28 -28 -34 -42 -34 -76 0 -34 6 -48 34 -76 29 -29 41
-34 79 -34 85 0 136 75 104 152 -19 44 -56 68 -108 68 -33 0 -47 -6 -75 -34z"/>
<path d="M10314 4336 c-47 -47 -48 -100 -3 -151 27 -31 37 -35 79 -35 58 0 95
26 109 75 21 78 -29 145 -109 145 -34 0 -48 -6 -76 -34z"/>
<path d="M9847 3602 c-32 -34 -33 -36 -6 -124 11 -39 19 -72 17 -74 -3 -2 -40
3 -83 11 l-78 15 -28 -32 c-16 -18 -28 -36 -29 -39 0 -6 196 -39 230 -39 8 0
40 -23 70 -50 30 -27 58 -50 62 -50 9 0 48 55 48 68 0 6 -4 12 -9 14 -5 2 -28
20 -51 41 -38 35 -44 48 -72 150 -38 145 -38 144 -71 109z"/>
<path d="M2696 3590 c-3 -8 -19 -67 -35 -130 -30 -115 -30 -115 -88 -167 l-58
-53 32 -32 31 -31 58 51 c47 42 65 52 93 52 50 0 204 21 214 29 4 4 -8 22 -27
40 l-34 33 -76 -13 c-41 -7 -78 -10 -82 -7 -3 4 4 40 15 80 12 41 21 78 21 84
0 5 -14 25 -30 44 -21 26 -30 31 -34 20z"/>
<path d="M9490 3215 l-104 -106 27 -26 27 -27 41 39 41 40 97 -102 c53 -57
101 -103 107 -103 6 0 22 13 37 28 l27 28 -105 104 -105 104 37 38 37 38 -24
25 c-13 14 -26 25 -30 25 -3 0 -53 -47 -110 -105z"/>
<path d="M2910 3188 c-70 -36 -103 -86 -108 -161 -3 -51 1 -70 20 -106 30 -57
80 -97 140 -112 41 -11 55 -10 102 5 45 13 63 26 91 63 82 107 49 242 -75 306
-65 33 -112 34 -170 5z m150 -87 c14 -10 33 -33 44 -50 16 -28 17 -38 7 -71
-23 -76 -101 -111 -170 -75 -31 15 -61 69 -61 107 0 58 77 124 130 113 14 -3
36 -14 50 -24z"/>
<path d="M9288 3023 l-26 -28 69 -80 c39 -44 93 -108 121 -142 l51 -62 31 26
c17 14 31 29 31 33 0 11 -235 280 -244 280 -4 0 -19 -12 -33 -27z"/>
<path d="M3278 2862 c-89 -120 -101 -145 -96 -202 6 -64 39 -107 105 -137 41
-19 62 -23 93 -18 54 9 77 30 160 145 69 96 72 102 54 115 -21 16 -54 29 -58
23 -2 -1 -34 -43 -71 -93 -38 -49 -73 -93 -79 -97 -23 -16 -67 -8 -91 17 -35
34 -32 73 9 131 19 27 51 72 71 101 l37 52 -29 25 c-15 14 -31 26 -34 26 -3 0
-35 -40 -71 -88z"/>
<path d="M9105 2868 c-11 -6 -55 -38 -97 -70 l-77 -58 112 -149 112 -149 29
16 c41 24 42 37 7 81 -37 47 -38 58 -8 72 19 8 36 6 84 -14 l61 -25 42 28 c47
31 47 30 -36 61 -32 12 -60 23 -62 24 -1 1 3 16 9 34 16 45 -12 116 -55 142
-35 21 -90 24 -121 7z m73 -84 c34 -24 28 -57 -20 -98 -23 -20 -45 -36 -48
-36 -8 0 -63 80 -58 84 22 18 93 66 97 66 4 0 17 -7 29 -16z"/>
<path d="M3669 2628 c-18 -29 -61 -100 -97 -158 l-64 -104 29 -23 c15 -13 33
-23 38 -23 6 0 22 23 38 50 24 45 29 49 48 40 27 -15 39 -50 39 -119 0 -56 1
-58 40 -80 22 -12 40 -19 41 -14 0 4 0 41 -1 81 l-1 72 35 0 c27 0 44 8 69 34
62 62 56 145 -14 196 -39 29 -154 100 -162 100 -3 0 -20 -24 -38 -52z m115
-86 c50 -35 64 -57 50 -79 -26 -41 -63 -40 -123 6 l-24 18 23 42 c13 22 26 41
29 41 3 -1 24 -13 45 -28z"/>
<path d="M8715 2602 c-89 -42 -131 -112 -123 -208 11 -128 154 -209 273 -155
144 65 165 251 40 347 -48 37 -131 44 -190 16z m129 -81 c37 -25 55 -57 56
-99 0 -65 -52 -122 -112 -122 -64 0 -126 80 -114 145 6 31 46 77 76 88 30 11
66 6 94 -12z"/>
<path d="M8392 2413 c-24 -13 -31 -21 -26 -36 15 -49 155 -317 165 -317 15 0
70 33 66 40 -1 3 -38 78 -82 167 -44 90 -82 163 -85 162 -3 0 -20 -8 -38 -16z"/>
<path d="M4168 2203 c-88 -192 -90 -174 31 -224 90 -37 149 -40 208 -10 73 37
109 105 101 192 -7 74 -42 111 -153 164 -51 25 -97 45 -102 45 -5 0 -43 -75
-85 -167z m169 47 c80 -38 105 -109 64 -176 -30 -49 -75 -60 -145 -34 -31 12
-56 23 -56 25 0 1 13 31 29 66 16 35 36 81 45 102 8 20 17 37 19 37 2 0 22 -9
44 -20z"/>
<path d="M8170 2301 c-45 -11 -190 -75 -190 -84 0 -4 14 -40 31 -80 17 -40 46
-112 65 -162 19 -49 39 -93 43 -98 6 -6 81 17 81 26 0 1 -9 26 -20 55 -25 65
-25 68 3 76 16 4 38 -5 80 -35 l58 -40 44 17 c25 9 45 19 45 23 0 3 -27 23
-60 45 -33 21 -60 41 -60 45 0 3 7 15 15 25 32 43 5 150 -43 175 -27 13 -65
19 -92 12z m48 -93 c7 -7 12 -25 12 -40 0 -23 -8 -32 -50 -53 -27 -14 -51 -25
-54 -25 -5 0 -36 77 -36 89 0 11 68 40 96 40 11 1 25 -4 32 -11z"/>
<path d="M4677 2093 c-34 -42 -90 -109 -124 -149 -35 -40 -63 -77 -63 -82 0
-5 17 -14 37 -20 34 -11 40 -9 64 14 l27 26 70 -24 c71 -23 82 -34 82 -83 0
-16 10 -24 41 -32 l42 -11 -7 142 c-4 77 -9 169 -13 203 l-6 62 -44 15 -44 15
-62 -76z m83 -112 l0 -70 -45 16 c-25 8 -45 17 -45 20 0 10 74 103 82 103 4 0
8 -31 8 -69z"/>
<path d="M7688 2122 c-43 -15 -78 -32 -78 -38 0 -23 111 -354 119 -354 16 0
71 22 71 28 0 4 -7 29 -15 56 -8 27 -15 52 -15 56 0 4 19 13 43 19 101 26 150
89 127 165 -6 21 -25 52 -40 68 -25 24 -36 28 -82 27 -29 -1 -88 -13 -130 -27z
m162 -78 c14 -35 -1 -58 -50 -78 -53 -21 -59 -20 -70 9 -24 64 -23 71 12 82
18 6 48 11 66 12 26 1 34 -4 42 -25z"/>
<path d="M4985 2076 c-18 -61 -17 -63 35 -76 28 -7 50 -16 50 -21 0 -5 -16
-72 -36 -149 -20 -78 -34 -143 -32 -146 3 -2 22 -5 43 -7 l38 -2 35 140 c19
77 36 142 38 144 2 2 26 -2 54 -9 28 -7 52 -11 54 -9 2 2 6 20 10 39 l6 35
-146 36 c-100 25 -147 33 -149 25z"/>
<path d="M7125 1981 c-58 -12 -79 -21 -78 -32 8 -52 65 -354 68 -358 2 -2 21
0 41 3 l36 7 -7 63 c-6 60 -5 64 17 69 19 5 32 -4 73 -49 l50 -56 48 7 c26 4
47 10 47 13 0 4 -23 30 -51 58 l-52 53 27 31 c50 60 28 168 -39 196 -43 17
-78 16 -180 -5z m141 -69 c6 -4 14 -16 18 -28 10 -32 -22 -61 -77 -72 -54 -11
-56 -10 -60 53 -2 36 0 40 28 46 42 9 78 10 91 1z"/>
<path d="M5336 1819 c-54 -88 -99 -168 -100 -177 -1 -13 9 -18 36 -20 31 -3
42 2 61 24 l24 27 76 -13 c75 -13 76 -13 84 -49 8 -33 12 -36 51 -42 51 -7 50
-11 18 131 -13 58 -29 135 -36 172 -15 82 -24 94 -75 101 l-40 6 -99 -160z
m146 -25 l16 -66 -47 7 c-25 4 -48 9 -50 11 -6 5 51 114 60 114 3 0 12 -30 21
-66z"/>
<path d="M6858 1935 c-2 -3 1 -58 9 -122 14 -131 8 -163 -33 -182 -38 -17 -62
-13 -88 12 -19 19 -24 38 -30 113 -4 49 -10 106 -13 128 -6 38 -6 38 -45 33
-22 -3 -41 -7 -42 -9 -2 -1 2 -62 9 -134 13 -140 25 -173 73 -209 39 -29 144
-28 192 2 62 38 74 71 67 182 -4 53 -9 117 -13 144 -7 46 -7 47 -44 47 -20 0
-39 -2 -42 -5z"/>
<path d="M6245 1891 c-78 -36 -115 -95 -115 -182 0 -114 80 -189 200 -189 160
0 253 174 163 304 -54 78 -161 107 -248 67z m156 -89 c42 -37 51 -110 20 -159
-38 -61 -139 -62 -184 -1 -23 31 -27 95 -9 130 33 62 121 77 173 30z"/>
<path d="M5726 1624 c-22 -22 -20 -50 6 -68 l22 -16 -23 -24 c-24 -26 -21 -46
7 -46 23 0 72 76 72 111 0 32 -23 59 -50 59 -10 0 -26 -7 -34 -16z"/>
</g>
</svg>






    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
